var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { id: "dialog" } },
    [
      _c(
        "v-card-text",
        { attrs: { id: "dialog_title" } },
        [_vm._t("title")],
        2
      ),
      _c("v-card-text", { attrs: { id: "dialog_body" } }, [_vm._t("body")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }